export const SidebarSectionList = ({ children }: React.PropsWithChildren<unknown>) => {
  return <section>{children}</section>;
};
